import React from 'react';
import Icon from '../../../components/AppIcon';

const LegalNotices = () => {
  const legalData = {
    lastUpdated: '23 Septembre 2025',
    companyInfo: {
      name: 'KAPITALSTATES SARL',
      registration: 'CI-ABJ-2024-B-12345',
      capital: '10,000,000 FCFA',
      address: 'ABIDJAN-COCODY, Angré 8ème Tranche\nSICOMEX, Cité Tonton Bouba\nRue L130, Villa Duplex n° B2',
      phone: '+225 21 50 00 53 18',
      email: 'legal@kapitalstates.com',
      website: 'www.kapitalstates.com'
    },
    licenses: [
      {
        type: 'Licence Agent Immobilier',
        number: 'AI-CI-2024-001',
        authority: 'Ministère de la Construction et de l\'Urbanisme',
        validity: '2024-2027'
      },
      {
        type: 'Agrément Services Numériques',
        number: 'SN-CI-2024-456',
        authority: 'ARTCI (Autorité de Régulation des Télécommunications)',
        validity: '2024-2026'
      }
    ],
    partnerships: [
      {
        partner: 'Chambre des Notaires de Côte d\'Ivoire',
        type: 'Partenariat Officiel',
        scope: 'Services notariaux certifiés'
      },
      {
        partner: 'Ordre des Géomètres-Experts',
        type: 'Collaboration Technique',
        scope: 'Vérification des titres fonciers'
      }
    ]
  };

  return (
    <div className="p-8">
      <div className="flex items-center space-x-4 mb-8">
        <div className="w-12 h-12 bg-brand-gold/10 rounded-xl flex items-center justify-center">
          <Icon name="Scale" size={24} color="var(--color-brand-earth)" />
        </div>
        <div>
          <h2 className="font-heading font-bold text-2xl text-brand-earth">
            Mentions Légales
          </h2>
          <p className="text-gray-600 text-sm">
            Dernière mise à jour: {legalData?.lastUpdated}
          </p>
        </div>
      </div>

      {/* Company Information */}
      <div className="bg-white border rounded-xl p-6 mb-8">
        <h3 className="font-heading font-semibold text-xl text-brand-earth mb-4 flex items-center space-x-2">
          <Icon name="Building2" size={20} color="var(--color-brand-earth)" />
          <span>Informations Légales de l'Entreprise</span>
        </h3>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="space-y-4">
            <div>
              <h4 className="font-body font-semibold text-gray-800 mb-2">Dénomination Sociale</h4>
              <p className="text-gray-700">{legalData?.companyInfo?.name}</p>
            </div>
            <div>
              <h4 className="font-body font-semibold text-gray-800 mb-2">Numéro d'Enregistrement</h4>
              <p className="text-gray-700">{legalData?.companyInfo?.registration}</p>
            </div>
            <div>
              <h4 className="font-body font-semibold text-gray-800 mb-2">Capital Social</h4>
              <p className="text-gray-700">{legalData?.companyInfo?.capital}</p>
            </div>
          </div>
          
          <div className="space-y-4">
            <div>
              <h4 className="font-body font-semibold text-gray-800 mb-2">Siège Social</h4>
              <p className="text-gray-700 whitespace-pre-line">{legalData?.companyInfo?.address}</p>
            </div>
            <div>
              <h4 className="font-body font-semibold text-gray-800 mb-2">Contact</h4>
              <div className="space-y-1 text-gray-700">
                <div className="flex items-center space-x-2">
                  <Icon name="Phone" size={14} color="var(--color-gray-600)" />
                  <span>{legalData?.companyInfo?.phone}</span>
                </div>
                <div className="flex items-center space-x-2">
                  <Icon name="Mail" size={14} color="var(--color-gray-600)" />
                  <span>{legalData?.companyInfo?.email}</span>
                </div>
                <div className="flex items-center space-x-2">
                  <Icon name="Globe" size={14} color="var(--color-gray-600)" />
                  <span>{legalData?.companyInfo?.website}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Professional Licenses */}
      <div className="bg-white border rounded-xl p-6 mb-8">
        <h3 className="font-heading font-semibold text-xl text-brand-earth mb-4 flex items-center space-x-2">
          <Icon name="Award" size={20} color="var(--color-brand-earth)" />
          <span>Licences et Agréments Professionnels</span>
        </h3>
        
        <div className="space-y-4">
          {legalData?.licenses?.map((license, index) => (
            <div key={index} className="p-4 bg-gray-50 rounded-lg">
              <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                <div>
                  <h4 className="font-body font-semibold text-gray-800 text-sm">Type de Licence</h4>
                  <p className="text-gray-700 text-sm">{license?.type}</p>
                </div>
                <div>
                  <h4 className="font-body font-semibold text-gray-800 text-sm">Numéro</h4>
                  <p className="text-gray-700 text-sm">{license?.number}</p>
                </div>
                <div>
                  <h4 className="font-body font-semibold text-gray-800 text-sm">Autorité Délivrante</h4>
                  <p className="text-gray-700 text-sm">{license?.authority}</p>
                </div>
                <div>
                  <h4 className="font-body font-semibold text-gray-800 text-sm">Validité</h4>
                  <p className="text-gray-700 text-sm">{license?.validity}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Professional Partnerships */}
      <div className="bg-white border rounded-xl p-6 mb-8">
        <h3 className="font-heading font-semibold text-xl text-brand-earth mb-4 flex items-center space-x-2">
          <Icon name="Handshake" size={20} color="var(--color-brand-earth)" />
          <span>Partenariats Professionnels Agréés</span>
        </h3>
        
        <div className="space-y-4">
          {legalData?.partnerships?.map((partnership, index) => (
            <div key={index} className="p-4 bg-brand-earth/5 rounded-lg">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div>
                  <h4 className="font-body font-semibold text-gray-800 text-sm">Partenaire</h4>
                  <p className="text-gray-700 text-sm">{partnership?.partner}</p>
                </div>
                <div>
                  <h4 className="font-body font-semibold text-gray-800 text-sm">Type de Partenariat</h4>
                  <p className="text-gray-700 text-sm">{partnership?.type}</p>
                </div>
                <div>
                  <h4 className="font-body font-semibold text-gray-800 text-sm">Domaine d'Application</h4>
                  <p className="text-gray-700 text-sm">{partnership?.scope}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Legal Disclaimers */}
      <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6 mb-8">
        <h3 className="font-heading font-semibold text-brand-earth mb-4 flex items-center space-x-2">
          <Icon name="AlertTriangle" size={20} color="var(--color-yellow-600)" />
          <span>Avertissements Légaux Importants</span>
        </h3>
        
        <div className="space-y-4 text-sm text-gray-700">
          <p>
            <strong>Vérification Obligatoire:</strong> Toute transaction immobilière doit être vérifiée 
            auprès des notaires partenaires agréés. Les informations sur les propriétés sont fournies 
            à titre indicatif et ne constituent pas un engagement contractuel.
          </p>
          <p>
            <strong>Responsabilité Limitée:</strong> KAPITALSTATES agit en qualité d'intermédiaire 
            technologique. La responsabilité légale des transactions relève des notaires agréés 
            conformément à la réglementation ivoirienne.
          </p>
          <p>
            <strong>Conformité Réglementaire:</strong> Tous nos services sont conformes aux lois 
            ivoiriennes en vigueur, notamment le Code Civil, le Code de Commerce et les réglementations 
            sectorielles applicables.
          </p>
        </div>
      </div>

      {/* Contact Legal */}
      <div className="p-6 bg-brand-earth/5 rounded-xl">
        <h3 className="font-heading font-semibold text-brand-earth mb-3">
          Service Juridique et Conformité
        </h3>
        <p className="text-gray-700 text-sm mb-4">
          Pour toute question relative aux aspects légaux ou réglementaires:
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
          <div className="flex items-center space-x-2">
            <Icon name="Users" size={16} color="var(--color-brand-earth)" />
            <span>Conseiller Juridique: Maître KONE Adjoa</span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="MapPin" size={16} color="var(--color-brand-earth)" />
            <span>Bureau: Plateau, Tour EECI, 15ème étage</span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="Mail" size={16} color="var(--color-brand-earth)" />
            <span>compliance@kapitalstates.com</span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="Phone" size={16} color="var(--color-brand-earth)" />
            <span>+225 21 50 00 53 20</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LegalNotices;